export const categoryProducts = [
  {
    id: 1,
    name: 'Cadeira',
    slug: 'chair'
  },
  {
    id: 2,
    name: 'Cama',
    slug: 'beds'
  },
  {
    id: 3,
    name: 'Sofá',
    slug: 'sofa'
  },
  {
    id: 4,
    name: 'Lâmpada',
    slug: 'lamp'
  }
];
